module.exports = __webpack_public_path__ + "img/B.1f85de2.jpg";